import Tooltip from './views/Tooltip.c';
export default Tooltip;
